import React, { createContext, useContext, useState } from "react";
import AccountModal from "../components/AccountModal";
import AuthModal from "../components/AuthModal";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../components/ui/dialog";
import { CheckCircle2 } from "lucide-react";

import { tr } from "../i18n";
const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [illustration, setIllustration] = useState(false);
  const [auth, setAuth] = useState({ open: false, role: "client", tab: "login" });
  const [thankYou, setThankYou] = useState(null);

  const openIllustration = () => setIllustration(true);
  const closeIllustration = () => setIllustration(false);

  const openLogin = (role = "client") =>
    setAuth({ open: true, role, tab: "login" });
  const closeAuth = () => setAuth((a) => ({ ...a, open: false }));

  return (
    <UIContext.Provider value={{ openIllustration, openLogin }}>
      {children}

      <AccountModal
        open={illustration}
        mode="illustration"
        onClose={closeIllustration}
        onSuccess={(name) => setThankYou(name)}
      />

      <AuthModal
        open={auth.open}
        onClose={closeAuth}
      />


      {/* Illustration / request received confirmation */}
      <Dialog open={!!thankYou} onOpenChange={(o) => !o && setThankYou(null)}>
        <DialogContent className="sm:max-w-[440px] p-0 overflow-hidden gap-0 border-0">
          <div className="bg-[#0b1f3a] px-7 pt-7 pb-6">
            <DialogHeader>
              <p className="text-[#c2a15a] text-[11px] tracking-[0.25em] uppercase mb-2">
                {tr("R&H Savings")}
              </p>
              <DialogTitle className="font-display text-white text-[26px] leading-tight">
                {tr("Request received")}
              </DialogTitle>
              <DialogDescription className="text-white/60 text-[14px] mt-1">
                {tr("Thank you — we'll be in touch shortly.")}
              </DialogDescription>
            </DialogHeader>
          </div>
          <div className="px-7 py-8 text-center">
            <div className="w-16 h-16 mx-auto rounded-full bg-[#f6f2e9] flex items-center justify-center mb-5">
              <CheckCircle2 size={32} className="text-[#c2a15a]" />
            </div>
            <p className="text-[#0b1f3a]/70 text-[15px] leading-relaxed max-w-sm mx-auto">
              {tr("Thank you,")} {thankYou}{tr("! Your illustration request has been received. A member of our team will prepare a tailored illustration and be in touch shortly.")}
            </p>
            <button
              onClick={() => setThankYou(null)}
              className="mt-7 inline-flex items-center gap-2 bg-[#0b1f3a] hover:bg-[#163561] text-white px-6 py-3 rounded-full text-[14px] font-medium transition-colors"
            >
              {tr("Close")}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </UIContext.Provider>
  );
}

export const useUI = () => useContext(UIContext);
